import { React, useState, useEffect } from "react";
import "./Css/Message.css";
import { getDatabase, get, child, ref } from "@firebase/database";
import { initializeApp } from "firebase/app";
import config from "./CONFIDENTIAL.js";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";

const getMessages = async () => {
  let msgs = await get(child(ref(getDatabase()), `/Users`));
  if (msgs.exists()) {
    var Data = [];
    Data = await msgs.val();
    return Data.reverse();
  }
}

function Messages() {
  const app = initializeApp(config);
  const [data, setData] = useState([]);
  useEffect(() => {
    getMessages().then(e => {
      setData(e);
      document.querySelector(".loader").style.visibility = 'hidden';
      document.querySelector(".loader").style.width = '0px';
      document.querySelector(".loader").style.height = '0px';
    }).catch(e => {
      alert("Some error occured!!");
    });
  }, []);
  return (
    <>
      <Navbar />
      <div className="details">
        <center className="loader">
          <img style={{ width: window.screen.width > 750 ? '3%' : '20%' }} src="spinner/Loader.gif" />
        </center>
        {data && data.map((e, idx) => {
          var Letter = e.name.slice(0, 1).toUpperCase();
          if (
            Letter === "A" ||
            Letter === "S" ||
            Letter === "D" ||
            Letter === "F" ||
            Letter === "G" ||
            Letter === "H" ||
            Letter === "J" ||
            Letter === "K" ||
            Letter === "L"
          ) {
            setTimeout(() => {
              document.getElementById(`${e.name}`).style.backgroundColor =
                "orange";
            }, 20);
          } else if (
            Letter === "Q" ||
            Letter === "W" ||
            Letter === "E" ||
            Letter === "R" ||
            Letter === "T" ||
            Letter === "Y" ||
            Letter === "U" ||
            Letter === "I" ||
            Letter === "O" ||
            Letter === "P"
          ) {
            setTimeout(() => {
              document.getElementById(`${e.name}`).style.backgroundColor = "blue";
            }, 20);
          } else if (
            Letter === "Z" ||
            Letter === "X" ||
            Letter === "C" ||
            Letter === "V" ||
            Letter === "B" ||
            Letter === "N" ||
            Letter === "M"
          ) {
            setTimeout(() => {
              document.getElementById(`${e.name}`).style.backgroundColor =
                "green";
            }, 20);
          }
          return (

            <div key={e.email} className="user-comments">
              <p id={e.name} className="user-image" style={{ marginRight: "2%" }}>
                {" "}{e.name.slice(0, 1).toUpperCase()}{" "}
              </p>
              <div id={e.email}>
                <b>
                  {e.name}
                </b>
                <p id="date" style={{ color: "gray" }}>
                  {e.postedOn}
                </p>
                <p id="comment">
                  {e.message}
                </p>
              </div>
            </div>
          );
        })}
        <br /><br /><br />
      </div>
      <Footer />
    </>
  );
};
export default Messages;
